@if (activeField(); as field) {
  <div cdkTrapFocus cdkTrapFocusAutoCapture class="table-filter-mobile-panel__focus-trap">
    <div class="table-filter-mobile-panel__subpage-header">
      <button
        type="button"
        class="table-filter-mobile-panel__icon-btn"
        [attr.aria-label]="backAriaLabel()"
        (click)="closeSubpage()"
      >
        <ocp-themed-icon name="chevron-left.svg" />
      </button>
      <span class="table-filter-mobile-panel__title">{{ field.labelKey | translate }}</span>
    </div>

    <div class="table-filter-mobile-panel__search">
      <ocp-themed-icon class="table-filter-mobile-panel__search-icon" name="search.svg" />
      <label for="table-filter-subpage-search" class="visually-hidden">
        {{ field.subpageSearchPlaceholder | translate }}
      </label>
      <input
        id="table-filter-subpage-search"
        type="text"
        class="table-filter-mobile-panel__search-input"
        [placeholder]="field.subpageSearchPlaceholder | translate"
        [value]="subpageQuery()"
        (input)="onSubpageSearchInput($event)"
      />
    </div>

    <div class="table-filter-mobile-panel__body">
      <button
        type="button"
        class="table-filter-mobile-panel__option"
        [attr.aria-pressed]="filterState().getSelectedCount(field.key)() === 0"
        [class.table-filter-mobile-panel__option--selected]="
          filterState().getSelectedCount(field.key)() === 0
        "
        (click)="filterState().clearField(field.key)"
      >
        <span class="table-filter-mobile-panel__checkmark-area">
          @if (filterState().getSelectedCount(field.key)() === 0) {
            <ocp-themed-icon name="checkmark.svg" [size]="16" />
          }
        </span>
        {{ showAllLabel() }}
      </button>

      @for (option of filteredSubpageOptions(); track trackByValue($index, option)) {
        <button
          type="button"
          class="table-filter-mobile-panel__option"
          [attr.aria-pressed]="filterState().getSelectedValues(field.key)().has(option.value)"
          [class.table-filter-mobile-panel__option--selected]="
            filterState().getSelectedValues(field.key)().has(option.value)
          "
          (click)="filterState().toggleValue(field.key, option.value)"
        >
          <span class="table-filter-mobile-panel__checkmark-area">
            @if (filterState().getSelectedValues(field.key)().has(option.value)) {
              <ocp-themed-icon name="checkmark.svg" [size]="16" />
            }
          </span>
          @if (option.labelKey) {
            {{ option.labelKey | translate }}
          } @else {
            <ocp-avatar
              [userInitials]="option.label | initials"
              [colorSeed]="option.email"
              size="md"
              class="table-filter-mobile-panel__option-avatar"
            />
            {{ option.label }}
          }
        </button>
      }
    </div>

    <button type="button" class="table-filter-mobile-panel__apply-btn" (click)="closeSubpage()">
      <ocp-themed-icon name="checkmark.svg" [size]="16" />
      {{ selectLabel() }}
    </button>
  </div>
} @else {
  <div cdkTrapFocus cdkTrapFocusAutoCapture class="table-filter-mobile-panel__focus-trap">
    <div class="table-filter-mobile-panel__header">
      <span class="table-filter-mobile-panel__title">{{ title() }}</span>
      <button
        type="button"
        class="table-filter-mobile-panel__clear-all"
        (click)="filterState().clearAll()"
      >
        {{ clearAllLabel() }}
      </button>
      <button
        type="button"
        class="table-filter-mobile-panel__icon-btn"
        [attr.aria-label]="closeAriaLabel()"
        (click)="panelClose.emit()"
      >
        <ocp-themed-icon name="cross.svg" />
      </button>
    </div>

    <div class="table-filter-mobile-panel__body">
      @for (field of filterState().fields; track trackByFieldKey($index, field)) {
        @if (field.mobileSubpage) {
          <button
            type="button"
            class="table-filter-mobile-panel__collapsed-row"
            (click)="openSubpage(field.key)"
          >
            <span class="table-filter-mobile-panel__collapsed-text">
              <span class="table-filter-mobile-panel__collapsed-label">{{
                field.labelKey | translate
              }}</span>
              <span class="table-filter-mobile-panel__collapsed-value">
                @if (filterState().getSelectedCount(field.key)(); as count) {
                  @if (count > 0) {
                    {{ selectedCountLabel()(count) }}
                  } @else {
                    {{ showAllLabel() }}
                  }
                } @else {
                  {{ showAllLabel() }}
                }
              </span>
            </span>
            <ocp-themed-icon
              class="table-filter-mobile-panel__collapsed-chevron"
              name="chevron-right.svg"
              [size]="12"
            />
          </button>
        } @else {
          <section class="table-filter-mobile-panel__section">
            <h3 class="table-filter-mobile-panel__section-title">
              {{ field.labelKey | translate }}
            </h3>

            <button
              type="button"
              class="table-filter-mobile-panel__option"
              [attr.aria-pressed]="filterState().getSelectedCount(field.key)() === 0"
              [class.table-filter-mobile-panel__option--selected]="
                filterState().getSelectedCount(field.key)() === 0
              "
              (click)="filterState().clearField(field.key)"
            >
              <span class="table-filter-mobile-panel__checkmark-area">
                @if (filterState().getSelectedCount(field.key)() === 0) {
                  <ocp-themed-icon name="checkmark.svg" [size]="16" />
                }
              </span>
              {{ showAllLabel() }}
            </button>

            @for (
              option of filterState().getFieldOptions(field.key)();
              track trackByValue($index, option)
            ) {
              <button
                type="button"
                class="table-filter-mobile-panel__option"
                [attr.aria-pressed]="filterState().getSelectedValues(field.key)().has(option.value)"
                [class.table-filter-mobile-panel__option--selected]="
                  filterState().getSelectedValues(field.key)().has(option.value)
                "
                (click)="filterState().toggleValue(field.key, option.value)"
              >
                <span class="table-filter-mobile-panel__checkmark-area">
                  @if (filterState().getSelectedValues(field.key)().has(option.value)) {
                    <ocp-themed-icon name="checkmark.svg" [size]="16" />
                  }
                </span>
                @if (option.modifier) {
                  <span
                    class="table-filter-mobile-panel__option-pill"
                    [class.table-filter-mobile-panel__option-pill--open]="
                      option.modifier === 'open'
                    "
                    [class.table-filter-mobile-panel__option-pill--resolved]="
                      option.modifier === 'resolved'
                    "
                    [class.table-filter-mobile-panel__option-pill--closed]="
                      option.modifier === 'closed'
                    "
                    [class.table-filter-mobile-panel__option-pill--low]="option.modifier === 'low'"
                    [class.table-filter-mobile-panel__option-pill--medium]="
                      option.modifier === 'medium'
                    "
                    [class.table-filter-mobile-panel__option-pill--high]="
                      option.modifier === 'high'
                    "
                  >
                    @if (
                      option.modifier === 'low' ||
                      option.modifier === 'medium' ||
                      option.modifier === 'high'
                    ) {
                      <span
                        class="table-filter-mobile-panel__option-dot"
                        [class.table-filter-mobile-panel__option-dot--low]="
                          option.modifier === 'low'
                        "
                        [class.table-filter-mobile-panel__option-dot--medium]="
                          option.modifier === 'medium'
                        "
                        [class.table-filter-mobile-panel__option-dot--high]="
                          option.modifier === 'high'
                        "
                      ></span>
                    }
                    @if (option.labelKey) {
                      {{ option.labelKey | translate }}
                    } @else {
                      {{ option.label }}
                    }
                  </span>
                } @else if (option.labelKey) {
                  {{ option.labelKey | translate }}
                } @else {
                  {{ option.label }}
                }
              </button>
            }
          </section>
        }
      }
    </div>

    <button type="button" class="table-filter-mobile-panel__apply-btn" (click)="panelClose.emit()">
      <ocp-themed-icon name="checkmark.svg" [size]="16" />
      {{ applyLabel() }}
    </button>
  </div>
}
